//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "SlugPage",
  transition: "default",
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: params.slug,
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );

      // console.log("SLUG QUERY: " + query);
      var data = await $axios.$get(
        `${process.env.api_url}/api/pages?${query}&populate=deep&locale=all`
      );
      const breakBlockData = await $axios.$get(
        `${process.env.api_url}/api/boxes-break-blocks?populate=deep&locale=all`
      );
      // console.log("SLUG PARAMS: ", params);
      // console.log("SLUG DATA: ", data.data);

      if (!data.data.length) {
        data = false;
      }
      
      return {
        data: {
          data: data.data[0],
          breakBlockData:
            breakBlockData.data.length && breakBlockData.data[0].attributes,
        },
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
};
